export default __webpack_public_path__ + "static/media/kartikey-new.png.webp";